import { useMutation, useQueryClient } from "react-query"
import { Auth } from "../../interface"
import { mutatePostFn } from "../../services/networking.service"
import ENDPOINTS from "../../services/endPoints"

interface INotifications {
    title: string
    message: string
}
export const usePostNotifications = () => {
    const queryClient = useQueryClient()
    return useMutation<Auth, never, INotifications>(data => mutatePostFn(ENDPOINTS.NOTIFICATIONS, data), {
        onSuccess: async () => {
            queryClient.invalidateQueries([])
        },
    })
}